import ServiceLocator from '../../../services/ServiceLocator';
import { AsyncAction } from '../../types';
import { RefreshTokenIfNeeded } from '../../auth/actions';
import { HandleError } from '../../../stores/page/actions';
import { API_USER_NAME_UPDATED, API_USER_PASSWORD_UPDATED, API_USER_PROFILE_LOADED, API_USER_REGISTER, API_USER_REMOVED, API_USER_ROLE_UPDATED, API_USERS_LOADED, ApiUserProfileActionTypes } from './types';
import { UserInfo } from '../../../api/dtos/user/UserProfile';
import { UserRoleResponse } from '../../../api/dtos/user/UserRoleResponse';

export function ApiGetUserProfile(): AsyncAction {
    return RefreshTokenIfNeeded(async dispatch => {
        const response = await ServiceLocator.UserProfileService.GetUserProfile();
        if (response.is_success) {
            dispatch(UserProfileLoaded(response.data));
        } else {
            dispatch(HandleError(response));
        }
    });
}

function UserProfileLoaded(user: UserInfo): ApiUserProfileActionTypes {
    return {
        type: API_USER_PROFILE_LOADED,
        user,
    };
}

export function UserNameUpdated(name: string): ApiUserProfileActionTypes {
    return {
        type: API_USER_NAME_UPDATED,
        name,
    };
}

export function UserPasswordUpdated(password: string): ApiUserProfileActionTypes {
    return {
        type: API_USER_PASSWORD_UPDATED,
        password,
    };
}

//management 
export function ApiGetUsers(): AsyncAction {
    return RefreshTokenIfNeeded(async dispatch => {
        const response = await ServiceLocator.ManagementService.GetUsers();
        if (response.is_success) {
            dispatch(UsersLoaded(response.data));
        } else {
            dispatch(HandleError(response));
        }
    });
};

export function UserRegistered(email: string, role: UserRoleResponse): ApiUserProfileActionTypes {
    return {
        type: API_USER_REGISTER,
        email,
        role,
    };
}
function UsersLoaded(users: UserInfo[]): ApiUserProfileActionTypes {
    return {
        type: API_USERS_LOADED,
        users,
    };
}

export function UserRoleUpdated(userId: number, role: UserRoleResponse): ApiUserProfileActionTypes {
    return {
        type: API_USER_ROLE_UPDATED,
        userId,
        role,
    };
}

export function UserRemoved(userId: number): ApiUserProfileActionTypes {
    return {
        type: API_USER_REMOVED,
        userId,
    };
}